import { Col, Row } from "react-bootstrap";

const StatItem = ({ label, value }) => (
  <div className="border rounded p-3 h-100 bg-light">
    <div className="text-muted small mb-1">{label}</div>
    <div className="fs-5 fw-semibold">
      {value === 0 || value ? value : "-"}
    </div>
  </div>
);

const RallyStatsSection = ({ rally }) => {
  return (
    <div className="mb-4">
      <h5 className="mb-3">Stats</h5>
      <Row className="g-3">
        <Col sm={4}>
          <StatItem label="Drivers" value={rally?.stats_drivers} />
        </Col>
        <Col sm={4}>
          <StatItem label="Events" value={rally?.stats_events} />
        </Col>
        <Col sm={4}>
          <StatItem label="Participants" value={rally?.stats_participants} />
        </Col>
      </Row>
    </div>
  );
};

export default RallyStatsSection;
